import { EntityWithIdAndDescription } from 'src/types'
import { HttpAxiosRequest } from '../httpAxiosBase'

const getEndpoint = (url = '') => `cache/grupos${url}`

export const HttpCacheGrupo = {
    getGrupos: (): Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(getEndpoint())
    },

    getGruposPorSistema: (codSistema: number): Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/${codSistema}`))
    },
    
    getGrupoTipos: (): Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(getEndpoint('/tipos'))
    }
} as const
